// extracted by mini-css-extract-plugin
export default {"tabNav":"index_tabNav_s7Nmz clearfix","link":"index_link_8VYFw","active":"index_active_71hDy"};